export default __webpack_public_path__ + "static/media/Icons_LindIn_copia.7fb927c4.svg";